import statusValues from '@modules/UserStatusModule/statusValues';
import UserStatusText from './UserStatusText';
import { Stack } from '@servicetitan/design-system';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';

type UserStatusDisplayProps = {
  status: UserSetAvailabilityStatus;
  wrapUpTimeInSeconds: number;
};

const UserStatusDisplay = ({
  status,
  wrapUpTimeInSeconds,
}: UserStatusDisplayProps) => {
  const minutes = Math.floor(wrapUpTimeInSeconds / 60);
  const seconds = Math.floor(wrapUpTimeInSeconds % 60);

  // Format minutes and seconds
  const formattedMinutes = minutes;
  const formattedSeconds = seconds.toString().padStart(2, '0');

  // Concatenate minutes and seconds with a colon
  const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

  const text = statusValues[status] || 'Unknown';

  // We only show the wrap-up timer if there is a wrap up task and the user is available
  if (wrapUpTimeInSeconds === 0) {
    return <UserStatusText text={text} />;
  }

  return (
    <Stack>
      <UserStatusText text={'Wrap up'} />
      <UserStatusText text={formattedTime} bold />
    </Stack>
  );
};

export default UserStatusDisplay;
